(function (global) {
  'use strict';

  var API_BASE = (typeof window !== 'undefined' && window.SPOTIFY_API_BASE)
    || 'https://api.musiquesolutions.com/api/spotify';

  function SpotifyClient(baseUrl) {
    this.baseUrl = baseUrl || API_BASE;
  }

  SpotifyClient.prototype._fetch = function (path) {
    return fetch(this.baseUrl + path).then(function (res) {
      return res.text().then(function (text) {
        var data;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (parseErr) {
          throw new Error('Spotify API returned an invalid response. Check that index.js is deployed on the server.');
        }
        if (!res.ok) {
          throw new Error(data.error || 'Spotify request failed');
        }
        return data;
      });
    });
  };

  SpotifyClient.prototype.search = function (query, limit) {
    var params = new URLSearchParams({ q: query });
    if (limit) params.set('limit', String(limit));
    return this._fetch('/search?' + params.toString()).then(function (data) {
      return data.tracks || [];
    });
  };

  SpotifyClient.prototype.getTrack = function (trackId) {
    return this._fetch('/track/' + encodeURIComponent(trackId)).then(function (data) {
      return data.track;
    });
  };

  SpotifyClient.prototype.resolve = function (input) {
    var params = new URLSearchParams({ q: input });
    return this._fetch('/resolve?' + params.toString()).then(function (data) {
      if (data.album && data.tracks) {
        return { album: data.album, tracks: data.tracks, track: null };
      }
      if (data.track) return { album: null, track: data.track, tracks: null };
      return { album: null, track: null, tracks: data.tracks || [] };
    });
  };

  SpotifyClient.prototype.isAvailable = function () {
    return this._fetch('/health').then(function () { return true; }).catch(function () { return false; });
  };

  global.SpotifyClient = SpotifyClient;
  global.spotifyClient = new SpotifyClient();
})(typeof window !== 'undefined' ? window : this);
